import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'shared/helper/translate';
import { getProgressPercentage } from '../../reducer';
var RubriqSetupProgressBar = function RubriqSetupProgressBar(_ref) {
  var progressPercentage = _ref.progressPercentage;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": t('progress-bar'),
    className: "progress rubriq-criteria-progress-bar",
    role: "progressbar",
    "aria-valuenow": progressPercentage,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar",
    style: {
      width: "".concat(progressPercentage, "%")
    }
  }));
};
var RubriqSetupProgress = function RubriqSetupProgress(_ref2) {
  var step = _ref2.step;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var progressPercentage = getProgressPercentage({
    curie: curie
  }, step);
  return /*#__PURE__*/React.createElement(RubriqSetupProgressBar, {
    progressPercentage: progressPercentage
  });
};
export default RubriqSetupProgress;